<template>
  <div class="prop-map">
    <div id="map" class="inner"></div>
    <div class="bottom">
      <p class="title">Check your travel time to the property</p>
      <input class="input"
             :class="{ active: isDrive, error: isError }"
             v-model="userPostcode"
             placeholder="Your postcode..."
             :disabled="isDrive"
             @input="handleError"
      />
      <button class="button" @click="travelTimeSearch">
        <span class="text">{{ buttonText }}</span>
      </button>
      <div class="search-drive" :class="{ active: isDrive }">
        <p class="result">Car</p>
        <p class="result">Distance: {{ distance }}mi</p>
        <p class="result">Time: {{ time }}hr</p>
      </div>
    </div>
  </div>
</template>

<script>
// image is used as example
// will need to replace
import imageTest from "../../assets/images/favicon.png"
export default {
  data: function () {
    return {
      mapCore: {},
      userPostcode: "",
      postCodeCoordinates: "",
      drive: {},
      isDrive: false,
      time: "",
      distance: "",
      buttonText: "Check",
      isError: false,
      // image is used as example
      // will need to replace
      image: imageTest,
      // use same maplibre version of snaptrip-engine
      mapData: [
        { 
          url:"//unpkg.com/maplibre-gl@1.15.2/dist/maplibre-gl.css",
          type:"css"
        },
        {
          url:"//unpkg.com/maplibre-gl@1.15.2/dist/maplibre-gl.js",
          type:"script"
        },
      ]
    };
  },
  props: {
    map: {
      type: Object,
      required: true,
    },
  },
  methods: {
    createMap: function () {
      let app = this,
        map = document.getElementById("map"),
        coords = app.$props.map.coords;
      app.mapCore = new maplibregl.Map({
        container: map,
        style: 'https://maps.geo.eu-west-1.amazonaws.com/maps/v0/maps/esrinav/style-descriptor?key=v1.public.eyJqdGkiOiI3MzZlYzI0ZS01NDA5LTRlMTAtOGZiMS01MjRhMTJhOTk1NDYifU1JoF2LfT4zW6B6vybaiYCh7KpG4zATM4r3rZm6udel1nPEz1sI-Ua8gP35gC-ursYNtX0mrPAgaHbCRDWzdGlVAeBjl09CBJgleA4TfahGyYnpGgKmSbyN4C6vAZ3-WpgrZYNguOT4VC9gbOkSS66Lhf68_N7uk-0Nv1Z5ojX_MZlcnrtE2NHAKirN3f3Qa4LXLu1HhxAgpL_laHOg9iBkQ8yC4LkpjEO5Kcd6bEHlc19K9o4WdUdDNqIpwqEyCquF6_p1EBeScrOR7lUdIb9n7VWfakjBAnIKYiuN7TVKxyP3b909PCleUC9yhwoVX10Wl4k8agl7dEtWf-AWA2o.ZGQzZDY2OGQtMWQxMy00ZTEwLWIyZGUtOGVjYzUzMjU3OGE4',
        center: coords,
        zoom: app.$props.map.zoom,
        minZoom: app.$props.map.minZoom,
        maxZoom: app.$props.map.maxZoom,
      });
      app.mapCore.addControl(new maplibregl.NavigationControl());

      app.mapCore.on('load', () => {
        const marker = new maplibregl.Marker().setLngLat(coords).addTo(app.mapCore)
      })
    },
    handleScroll: function (e) {
      let app = this;
      let scroll = e.currentTarget.pageYOffset;
      let map = app.el.getBoundingClientRect().top;
      let isShowing = app.inViewport(app.el);
      if (scroll > map && isShowing) {
        app.mapData.forEach( data => st.assetLoader(data.url, data.type))
        app.createMap();
        window.removeEventListener("scroll", this.handleScroll);
      }
    },
    inViewport: function (el) {
      let box = el.getBoundingClientRect();
      return (
        box.top >= 0 &&
        box.left >= 0 &&
        box.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        Math.floor(box.right) <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    travelTimeSearch: function() {
      /**
       * Map Routing Feature for an Alternative AWS Map
       * 1. travelTimeSearch(): Initiates the routing process
       * 2. getGeocode(): Retrieves longitude and latitude based on the provided zipcode by using AWS
       * 3. getDir(): Utilizes existing features to draw the specified route on the map
       */
      let app = this;
      if (app.userPostcode) {
        app.getGeocode(app);
      }
    },
    getGeocode () {
      const app = this;
      const url = 'https://places.geo.eu-west-1.amazonaws.com/places/v0/indexes/uk_esri/search/text?key=v1.public.eyJqdGkiOiIwYzg0NDkyZC1hNjg0LTQyZTQtYjQ1Mi04ZjRlZjNkNWM3N2MifaDEAfAcHbT9OgLByndcnJzXzvuOheMtQ40yzrlbbQqYkpUFqtUlSlv_Ky7n6AQ0iAGb-CrUFzhovHxPe7IfZdf5F6jOBI_yFZd51bRVIjg2utmVdiLxbyGwOtKdNzggnk4JVIjQp76J4eO99bFmbSDVnWcCCCI-hc95Ld1c-QyEM2-aJ79eY0HLIhW6Gqo0jCpHN27vEL2cBXdDJvQfIOeIcSvklLnxcizWDSg_VGJd2sYJp5YxcJgKlMleoL2_ThsfFT9wa4LVqP5oFNcRFVFFSycpLKyNGUiKu9pz7xk4nLiwSx983c0KyZ4hhkAKArb_NMXm8Lyo_prFXHDJJ94.ZGQzZDY2OGQtMWQxMy00ZTEwLWIyZGUtOGVjYzUzMjU3OGE4'
      const data = {
        text: app.userPostcode
      }

      fetch(url, {
        method: 'POST',
        headers : {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error. Status: ${response.status}`)
        } 

        return response.json();
      })
      .then(data => {
        const lon = data.Results[0].Place.Geometry.Point[0];
        const lat = data.Results[0].Place.Geometry.Point[1];
        app.postCodeCoordinates =  [lon, lat];
        app.getDir();
      })
      .catch(error => {
        app.isError = true;
        console.error('Fetch error: ', error); 
      });
    },
    getDir: function () {
      const app = this;
      const lng = this.$props.map.coords[0];
      const lat = this.$props.map.coords[1];

      if (app.isDrive) {
        const map = app.mapCore;

        // remove existing layer and route
        if (map.getLayer('routeLayer')) {
          map.removeLayer('routeLayer');
        }

        if (map.getSource('routeSource')) {
          map.removeSource('routeSource');
        }

        app.isDrive = false;
        app.buttonText = "Check";
        app.distance = "";
        app.time = "";
        app.userPostcode = "";
        map.setCenter([lng, lat]);
        map.setZoom(15);
      } else {
        // alternative map route URL 
        const url = 'https://routes.geo.eu-west-1.amazonaws.com/routes/v0/calculators/esri/calculate/route?key=v1.public.eyJqdGkiOiI3MzZlYzI0ZS01NDA5LTRlMTAtOGZiMS01MjRhMTJhOTk1NDYifU1JoF2LfT4zW6B6vybaiYCh7KpG4zATM4r3rZm6udel1nPEz1sI-Ua8gP35gC-ursYNtX0mrPAgaHbCRDWzdGlVAeBjl09CBJgleA4TfahGyYnpGgKmSbyN4C6vAZ3-WpgrZYNguOT4VC9gbOkSS66Lhf68_N7uk-0Nv1Z5ojX_MZlcnrtE2NHAKirN3f3Qa4LXLu1HhxAgpL_laHOg9iBkQ8yC4LkpjEO5Kcd6bEHlc19K9o4WdUdDNqIpwqEyCquF6_p1EBeScrOR7lUdIb9n7VWfakjBAnIKYiuN7TVKxyP3b909PCleUC9yhwoVX10Wl4k8agl7dEtWf-AWA2o.ZGQzZDY2OGQtMWQxMy00ZTEwLWIyZGUtOGVjYzUzMjU3OGE4';

        const data = {
          DeparturePosition: app.postCodeCoordinates,
          DestinationPosition: [lng, lat],
          DistanceUnit: "Miles",
          TravelMode: 'Car' ,
          IncludeLegGeometry: true
        };
        
        // Use st.fetch if it is possible
        fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          if (!response.ok) {
              throw new Error(`HTTP error. Status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          const geocodes = data.Legs[0].Geometry.LineString
          const coordinates = [];

          geocodes.map((geocode, i)=> {
              coordinates.push([geocode[0], geocode[1]])
          })

          const map = app.mapCore;

          if (coordinates.length > 0) {
              const routeGeoJSON = {
                'type': 'Feature',
                'properties': {},
                'geometry': {
                  'type': 'LineString',
                  'coordinates': coordinates 
                }
              };

              map.addSource('routeSource', {
                  'type': 'geojson',
                  'data': routeGeoJSON
              })
  
              // Add the route layer
              map.addLayer({
                'id': 'routeLayer',
                'type': 'line',
                'source': 'routeSource',
                'layout': {
                  'line-join': 'round',
                  'line-cap': 'round'
                },
                'paint': {
                  'line-color': '#3FB1CE', 
                  'line-width': 4
                }
              });
          }

          const destination = [lng, lat];

          app.mapCore.fitBounds([coordinates[0], destination], {
              padding: {top: 40, bottom:20, left: 40, right: 40},
              maxZoom: 15
          });

          app.buttonText = "Remove";
          app.isDrive = true;

          app.distance = parseInt(data.Summary.Distance);
          app.time = Math.ceil((data.Summary.DurationSeconds / 3600) * 2) / 2;
        })
        .catch(error => {
          app.isError = true;
          console.error('Fetch error: ', error); 
        });
      }
    },
    handleError: function() {
      this.isError = false;
    }
  },
  mounted: function () {
    this.el = this.$el;
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy: function () {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="scss">
@import "app/assets/stylesheets/_vars.scss";

.prop-map {
  .inner {
    background: $col_white;
    top: 0.0625rem;
    height: 18rem;
    width: 100%;
  }

  .bottom {
    padding: 1rem;
    background-color: $col_xlgrey;
  }

  .title {
    margin-bottom: 0.625rem;
  }

  .input {
    height: 2.25rem;
    width: 8rem;
    border-radius: 0.25rem;
    padding-left: 1rem;
    outline: none;
    margin-bottom: 0.625rem;
    
    &.active {
      border: 0.0625rem solid $col_darkgrey;
    }

    @media  #{$desktop} {
      width: 14rem;
    }
  }

  .button {
    height: 2.25rem;
    width: 8rem;
    background-color: $col_primary;
    border-radius: 0.25rem;
    padding: 0.5rem 2.25rem 0.5rem 2.25rem;
    cursor: pointer;
  }

  .search-drive {
    max-height: 0;
    display: none;
    transition: 0.3s ease-in;
    padding: 0.625rem 0 0 0;

    &.active {
      display: flex;
      max-height: 3rem;
      transition: 0.3s ease-out;
    }

    .result {
      padding-right: 1rem;
    }
  }

  .text {
    color: $col_white;
    font-weight: 700;
  }
}

</style>